import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type TripSaveFieldsFragment = {
  __typename?: 'TripSave';
  id: string;
  eventId: string;
  tripType: string;
  kind: Types.TripSaveKind;
  referenceId?: string | null;
  note?: string | null;
  checkIn?: string | null;
  checkOut?: string | null;
  savedBy: string;
  boardId: string;
  tripPlanId?: string | null;
  createdAt: any;
  destination?: { __typename?: 'TripSaveDestination'; key: string; name: string; lat?: number | null; lng?: number | null } | null;
  car?: {
    __typename?: 'TripSaveCar';
    name: string;
    category?: string | null;
    imageUrl?: string | null;
    vendorName?: string | null;
    pickupName?: string | null;
    pickupCity?: string | null;
    lat?: number | null;
    lng?: number | null;
    dailyRateMinorUnits?: number | null;
    currency?: string | null;
    passengers?: number | null;
    transmission?: string | null;
  } | null;
};

export type TripSavesQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  tripType?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type TripSavesQuery = {
  __typename?: 'Query';
  tripSaves: Array<{
    __typename?: 'TripSave';
    id: string;
    eventId: string;
    tripType: string;
    kind: Types.TripSaveKind;
    referenceId?: string | null;
    note?: string | null;
    checkIn?: string | null;
    checkOut?: string | null;
    savedBy: string;
    boardId: string;
    tripPlanId?: string | null;
    createdAt: any;
    destination?: { __typename?: 'TripSaveDestination'; key: string; name: string; lat?: number | null; lng?: number | null } | null;
    car?: {
      __typename?: 'TripSaveCar';
      name: string;
      category?: string | null;
      imageUrl?: string | null;
      vendorName?: string | null;
      pickupName?: string | null;
      pickupCity?: string | null;
      lat?: number | null;
      lng?: number | null;
      dailyRateMinorUnits?: number | null;
      currency?: string | null;
      passengers?: number | null;
      transmission?: string | null;
    } | null;
  }>;
};

export type AddTripSaveMutationVariables = Types.Exact<{
  payload: Types.AddTripSaveRequest;
}>;

export type AddTripSaveMutation = { __typename?: 'Mutation'; addTripSave: { __typename?: 'TripSave'; id: string } };

export type UpdateTripSaveNoteMutationVariables = Types.Exact<{
  payload: Types.UpdateTripSaveNoteRequest;
}>;

export type UpdateTripSaveNoteMutation = { __typename?: 'Mutation'; updateTripSaveNote: { __typename?: 'TripSave'; id: string } };

export type RemoveTripSaveMutationVariables = Types.Exact<{
  payload: Types.RemoveTripSaveRequest;
}>;

export type RemoveTripSaveMutation = { __typename?: 'Mutation'; removeTripSave: { __typename?: 'TripSave'; id: string } };

export type TripBoardPlacesQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;

export type TripBoardPlacesQuery = {
  __typename?: 'Query';
  joyPlacesByIds?: Array<{
    __typename?: 'JoyPlace';
    id: string;
    name?: string | null;
    city?: string | null;
    state?: string | null;
    country?: string | null;
    lat?: number | null;
    long?: number | null;
    userRating?: { __typename?: 'UserRating'; ratingValue?: number | null; ratingCount?: number | null } | null;
    photo?: { __typename?: 'Photo'; id: string; url: string } | null;
  }> | null;
};

export type TripBoardFieldsFragment = {
  __typename?: 'TripBoard';
  id: string;
  eventId: string;
  tripType: string;
  name: string;
  checkIn?: string | null;
  checkOut?: string | null;
  dateWindow?: string | null;
  updatedBy?: string | null;
  updatedAt: any;
};

export type TripBoardWindowQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  tripType?: Types.InputMaybe<Types.Scalars['String']>;
  boardId?: Types.InputMaybe<Types.Scalars['ID']>;
}>;

export type TripBoardWindowQuery = {
  __typename?: 'Query';
  tripBoard?: {
    __typename?: 'TripBoard';
    id: string;
    eventId: string;
    tripType: string;
    name: string;
    checkIn?: string | null;
    checkOut?: string | null;
    dateWindow?: string | null;
    updatedBy?: string | null;
    updatedAt: any;
  } | null;
};

export type TripBoardsQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  tripType?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type TripBoardsQuery = {
  __typename?: 'Query';
  tripBoards: Array<{ __typename?: 'TripBoard'; id: string; name: string; saveCount?: number | null; createdAt: any; checkIn?: string | null; checkOut?: string | null }>;
};

export type CreateTripBoardMutationVariables = Types.Exact<{
  payload: Types.CreateTripBoardRequest;
}>;

export type CreateTripBoardMutation = { __typename?: 'Mutation'; createTripBoard: { __typename?: 'TripBoard'; id: string; name: string } };

export type RenameTripBoardMutationVariables = Types.Exact<{
  payload: Types.RenameTripBoardRequest;
}>;

export type RenameTripBoardMutation = { __typename?: 'Mutation'; renameTripBoard: { __typename?: 'TripBoard'; id: string; name: string } };

export type DeleteTripBoardMutationVariables = Types.Exact<{
  payload: Types.DeleteTripBoardRequest;
}>;

export type DeleteTripBoardMutation = { __typename?: 'Mutation'; deleteTripBoard: { __typename?: 'TripBoard'; id: string } };

export type SetTripBoardDatesMutationVariables = Types.Exact<{
  payload: Types.SetTripBoardDatesRequest;
}>;

export type SetTripBoardDatesMutation = { __typename?: 'Mutation'; setTripBoardDates: { __typename?: 'TripBoard'; id: string } };

export type TripBoardPricingQueryVariables = Types.Exact<{
  payload: Types.TravelPlacePricingAndBookingDetailsPayload;
}>;

export type TripBoardPricingQuery = {
  __typename?: 'Query';
  travelPlacesPricingAndBookingDetails: {
    __typename?: 'TravelPlacePricingAndBookingDetailsResult';
    joyPlaces: Array<{
      __typename?: 'JoyPlacePricingAndBookingDetails';
      joyPlace: { __typename?: 'JoyPlace'; id: string };
      pricingInfo?: {
        __typename?: 'PricingForAccommodationPlace';
        nightlyBaseRate: { __typename?: 'TravelMonetaryValue'; floatingPointDecimalString: string; currency: Types.TravelCurrencyCode };
        totalRate: { __typename?: 'TravelMonetaryValue'; floatingPointDecimalString: string; currency: Types.TravelCurrencyCode };
        allInTotalRate: { __typename?: 'TravelMonetaryValue'; floatingPointDecimalString: string; currency: Types.TravelCurrencyCode };
        strikeoutTotalRate?: { __typename?: 'TravelMonetaryValue'; floatingPointDecimalString: string; currency: Types.TravelCurrencyCode } | null;
      } | null;
    }>;
  };
};

export const TripSaveFieldsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TripSaveFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TripSave' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tripType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkIn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkOut' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'car' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendorName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pickupName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pickupCity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dailyRateMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passengers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transmission' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'savedBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'boardId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tripPlanId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TripBoardFieldsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TripBoardFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TripBoard' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tripType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkIn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkOut' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateWindow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TripSavesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TripSaves' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tripType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tripSaves' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'tripType' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'tripType' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'allBoards' }, value: { kind: 'BooleanValue', value: true } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripSaveFields' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TripSaveFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TripSave' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tripType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkIn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkOut' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'car' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendorName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pickupName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pickupCity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dailyRateMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passengers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transmission' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'savedBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'boardId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tripPlanId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTripSavesQuery__
 *
 * To run a query within a React component, call `useTripSavesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripSavesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTripSavesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      tripType: // value for 'tripType'
 *   },
 * });
 */
export function useTripSavesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TripSavesQuery, TripSavesQueryVariables>) {
  return ApolloReactHooks.useQuery<TripSavesQuery, TripSavesQueryVariables>(TripSavesDocument, baseOptions);
}
export function useTripSavesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TripSavesQuery, TripSavesQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<TripSavesQuery, TripSavesQueryVariables>(TripSavesDocument, baseOptions);
}
export type TripSavesQueryHookResult = ReturnType<typeof useTripSavesQuery>;
export type TripSavesLazyQueryHookResult = ReturnType<typeof useTripSavesLazyQuery>;
export type TripSavesQueryResult = Apollo.QueryResult<TripSavesQuery, TripSavesQueryVariables>;
export const AddTripSaveDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddTripSave' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddTripSaveRequest' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addTripSave' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AddTripSaveMutationFn = Apollo.MutationFunction<AddTripSaveMutation, AddTripSaveMutationVariables>;

/**
 * __useAddTripSaveMutation__
 *
 * To run a mutation, you first call `useAddTripSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTripSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTripSaveMutation, { data, loading, error }] = useAddTripSaveMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddTripSaveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddTripSaveMutation, AddTripSaveMutationVariables>) {
  return ApolloReactHooks.useMutation<AddTripSaveMutation, AddTripSaveMutationVariables>(AddTripSaveDocument, baseOptions);
}
export type AddTripSaveMutationHookResult = ReturnType<typeof useAddTripSaveMutation>;
export type AddTripSaveMutationResult = Apollo.MutationResult<AddTripSaveMutation>;
export type AddTripSaveMutationOptions = Apollo.BaseMutationOptions<AddTripSaveMutation, AddTripSaveMutationVariables>;
export const UpdateTripSaveNoteDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTripSaveNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateTripSaveNoteRequest' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTripSaveNote' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateTripSaveNoteMutationFn = Apollo.MutationFunction<UpdateTripSaveNoteMutation, UpdateTripSaveNoteMutationVariables>;

/**
 * __useUpdateTripSaveNoteMutation__
 *
 * To run a mutation, you first call `useUpdateTripSaveNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTripSaveNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTripSaveNoteMutation, { data, loading, error }] = useUpdateTripSaveNoteMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateTripSaveNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTripSaveNoteMutation, UpdateTripSaveNoteMutationVariables>) {
  return ApolloReactHooks.useMutation<UpdateTripSaveNoteMutation, UpdateTripSaveNoteMutationVariables>(UpdateTripSaveNoteDocument, baseOptions);
}
export type UpdateTripSaveNoteMutationHookResult = ReturnType<typeof useUpdateTripSaveNoteMutation>;
export type UpdateTripSaveNoteMutationResult = Apollo.MutationResult<UpdateTripSaveNoteMutation>;
export type UpdateTripSaveNoteMutationOptions = Apollo.BaseMutationOptions<UpdateTripSaveNoteMutation, UpdateTripSaveNoteMutationVariables>;
export const RemoveTripSaveDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveTripSave' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'RemoveTripSaveRequest' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeTripSave' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RemoveTripSaveMutationFn = Apollo.MutationFunction<RemoveTripSaveMutation, RemoveTripSaveMutationVariables>;

/**
 * __useRemoveTripSaveMutation__
 *
 * To run a mutation, you first call `useRemoveTripSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTripSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTripSaveMutation, { data, loading, error }] = useRemoveTripSaveMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useRemoveTripSaveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveTripSaveMutation, RemoveTripSaveMutationVariables>) {
  return ApolloReactHooks.useMutation<RemoveTripSaveMutation, RemoveTripSaveMutationVariables>(RemoveTripSaveDocument, baseOptions);
}
export type RemoveTripSaveMutationHookResult = ReturnType<typeof useRemoveTripSaveMutation>;
export type RemoveTripSaveMutationResult = Apollo.MutationResult<RemoveTripSaveMutation>;
export type RemoveTripSaveMutationOptions = Apollo.BaseMutationOptions<RemoveTripSaveMutation, RemoveTripSaveMutationVariables>;
export const TripBoardPlacesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TripBoardPlaces' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: { kind: 'NonNullType', type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'joyPlacesByIds' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'ids' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'long' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userRating' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ratingValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ratingCount' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTripBoardPlacesQuery__
 *
 * To run a query within a React component, call `useTripBoardPlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripBoardPlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTripBoardPlacesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useTripBoardPlacesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TripBoardPlacesQuery, TripBoardPlacesQueryVariables>) {
  return ApolloReactHooks.useQuery<TripBoardPlacesQuery, TripBoardPlacesQueryVariables>(TripBoardPlacesDocument, baseOptions);
}
export function useTripBoardPlacesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TripBoardPlacesQuery, TripBoardPlacesQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<TripBoardPlacesQuery, TripBoardPlacesQueryVariables>(TripBoardPlacesDocument, baseOptions);
}
export type TripBoardPlacesQueryHookResult = ReturnType<typeof useTripBoardPlacesQuery>;
export type TripBoardPlacesLazyQueryHookResult = ReturnType<typeof useTripBoardPlacesLazyQuery>;
export type TripBoardPlacesQueryResult = Apollo.QueryResult<TripBoardPlacesQuery, TripBoardPlacesQueryVariables>;
export const TripBoardWindowDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TripBoardWindow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tripType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        { kind: 'VariableDefinition', variable: { kind: 'Variable', name: { kind: 'Name', value: 'boardId' } }, type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tripBoard' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'tripType' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'tripType' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'boardId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'boardId' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripBoardFields' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TripBoardFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TripBoard' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tripType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkIn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkOut' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateWindow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTripBoardWindowQuery__
 *
 * To run a query within a React component, call `useTripBoardWindowQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripBoardWindowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTripBoardWindowQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      tripType: // value for 'tripType'
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useTripBoardWindowQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TripBoardWindowQuery, TripBoardWindowQueryVariables>) {
  return ApolloReactHooks.useQuery<TripBoardWindowQuery, TripBoardWindowQueryVariables>(TripBoardWindowDocument, baseOptions);
}
export function useTripBoardWindowLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TripBoardWindowQuery, TripBoardWindowQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<TripBoardWindowQuery, TripBoardWindowQueryVariables>(TripBoardWindowDocument, baseOptions);
}
export type TripBoardWindowQueryHookResult = ReturnType<typeof useTripBoardWindowQuery>;
export type TripBoardWindowLazyQueryHookResult = ReturnType<typeof useTripBoardWindowLazyQuery>;
export type TripBoardWindowQueryResult = Apollo.QueryResult<TripBoardWindowQuery, TripBoardWindowQueryVariables>;
export const TripBoardsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TripBoards' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tripType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tripBoards' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'tripType' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'tripType' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'saveCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkIn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkOut' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTripBoardsQuery__
 *
 * To run a query within a React component, call `useTripBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripBoardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTripBoardsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      tripType: // value for 'tripType'
 *   },
 * });
 */
export function useTripBoardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TripBoardsQuery, TripBoardsQueryVariables>) {
  return ApolloReactHooks.useQuery<TripBoardsQuery, TripBoardsQueryVariables>(TripBoardsDocument, baseOptions);
}
export function useTripBoardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TripBoardsQuery, TripBoardsQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<TripBoardsQuery, TripBoardsQueryVariables>(TripBoardsDocument, baseOptions);
}
export type TripBoardsQueryHookResult = ReturnType<typeof useTripBoardsQuery>;
export type TripBoardsLazyQueryHookResult = ReturnType<typeof useTripBoardsLazyQuery>;
export type TripBoardsQueryResult = Apollo.QueryResult<TripBoardsQuery, TripBoardsQueryVariables>;
export const CreateTripBoardDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateTripBoard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateTripBoardRequest' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTripBoard' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateTripBoardMutationFn = Apollo.MutationFunction<CreateTripBoardMutation, CreateTripBoardMutationVariables>;

/**
 * __useCreateTripBoardMutation__
 *
 * To run a mutation, you first call `useCreateTripBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTripBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTripBoardMutation, { data, loading, error }] = useCreateTripBoardMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateTripBoardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTripBoardMutation, CreateTripBoardMutationVariables>) {
  return ApolloReactHooks.useMutation<CreateTripBoardMutation, CreateTripBoardMutationVariables>(CreateTripBoardDocument, baseOptions);
}
export type CreateTripBoardMutationHookResult = ReturnType<typeof useCreateTripBoardMutation>;
export type CreateTripBoardMutationResult = Apollo.MutationResult<CreateTripBoardMutation>;
export type CreateTripBoardMutationOptions = Apollo.BaseMutationOptions<CreateTripBoardMutation, CreateTripBoardMutationVariables>;
export const RenameTripBoardDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RenameTripBoard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'RenameTripBoardRequest' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renameTripBoard' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type RenameTripBoardMutationFn = Apollo.MutationFunction<RenameTripBoardMutation, RenameTripBoardMutationVariables>;

/**
 * __useRenameTripBoardMutation__
 *
 * To run a mutation, you first call `useRenameTripBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameTripBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameTripBoardMutation, { data, loading, error }] = useRenameTripBoardMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useRenameTripBoardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RenameTripBoardMutation, RenameTripBoardMutationVariables>) {
  return ApolloReactHooks.useMutation<RenameTripBoardMutation, RenameTripBoardMutationVariables>(RenameTripBoardDocument, baseOptions);
}
export type RenameTripBoardMutationHookResult = ReturnType<typeof useRenameTripBoardMutation>;
export type RenameTripBoardMutationResult = Apollo.MutationResult<RenameTripBoardMutation>;
export type RenameTripBoardMutationOptions = Apollo.BaseMutationOptions<RenameTripBoardMutation, RenameTripBoardMutationVariables>;
export const DeleteTripBoardDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteTripBoard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteTripBoardRequest' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTripBoard' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteTripBoardMutationFn = Apollo.MutationFunction<DeleteTripBoardMutation, DeleteTripBoardMutationVariables>;

/**
 * __useDeleteTripBoardMutation__
 *
 * To run a mutation, you first call `useDeleteTripBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTripBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTripBoardMutation, { data, loading, error }] = useDeleteTripBoardMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useDeleteTripBoardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTripBoardMutation, DeleteTripBoardMutationVariables>) {
  return ApolloReactHooks.useMutation<DeleteTripBoardMutation, DeleteTripBoardMutationVariables>(DeleteTripBoardDocument, baseOptions);
}
export type DeleteTripBoardMutationHookResult = ReturnType<typeof useDeleteTripBoardMutation>;
export type DeleteTripBoardMutationResult = Apollo.MutationResult<DeleteTripBoardMutation>;
export type DeleteTripBoardMutationOptions = Apollo.BaseMutationOptions<DeleteTripBoardMutation, DeleteTripBoardMutationVariables>;
export const SetTripBoardDatesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetTripBoardDates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetTripBoardDatesRequest' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setTripBoardDates' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetTripBoardDatesMutationFn = Apollo.MutationFunction<SetTripBoardDatesMutation, SetTripBoardDatesMutationVariables>;

/**
 * __useSetTripBoardDatesMutation__
 *
 * To run a mutation, you first call `useSetTripBoardDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTripBoardDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTripBoardDatesMutation, { data, loading, error }] = useSetTripBoardDatesMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetTripBoardDatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetTripBoardDatesMutation, SetTripBoardDatesMutationVariables>) {
  return ApolloReactHooks.useMutation<SetTripBoardDatesMutation, SetTripBoardDatesMutationVariables>(SetTripBoardDatesDocument, baseOptions);
}
export type SetTripBoardDatesMutationHookResult = ReturnType<typeof useSetTripBoardDatesMutation>;
export type SetTripBoardDatesMutationResult = Apollo.MutationResult<SetTripBoardDatesMutation>;
export type SetTripBoardDatesMutationOptions = Apollo.BaseMutationOptions<SetTripBoardDatesMutation, SetTripBoardDatesMutationVariables>;
export const TripBoardPricingDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TripBoardPricing' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelPlacePricingAndBookingDetailsPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelPlacesPricingAndBookingDetails' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'joyPlaces' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'joyPlace' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pricingInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nightlyBaseRate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalRate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'allInTotalRate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'strikeoutTotalRate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTripBoardPricingQuery__
 *
 * To run a query within a React component, call `useTripBoardPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripBoardPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTripBoardPricingQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useTripBoardPricingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TripBoardPricingQuery, TripBoardPricingQueryVariables>) {
  return ApolloReactHooks.useQuery<TripBoardPricingQuery, TripBoardPricingQueryVariables>(TripBoardPricingDocument, baseOptions);
}
export function useTripBoardPricingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TripBoardPricingQuery, TripBoardPricingQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<TripBoardPricingQuery, TripBoardPricingQueryVariables>(TripBoardPricingDocument, baseOptions);
}
export type TripBoardPricingQueryHookResult = ReturnType<typeof useTripBoardPricingQuery>;
export type TripBoardPricingLazyQueryHookResult = ReturnType<typeof useTripBoardPricingLazyQuery>;
export type TripBoardPricingQueryResult = Apollo.QueryResult<TripBoardPricingQuery, TripBoardPricingQueryVariables>;
